import { Box, Spinner } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../utils/constants";
import { useCompany } from "../../components/layout/CompanyWrapper";

// "/": once the company is known (CompanyWrapper's bootstrap: from the cookies,
// or looked up again after a fresh login), go to the page the user came from
// (localStorage "from", when it's one of this app's pages) or the dashboard.
// No company: CompanyWrapper sends the user to the account app.
const CheckInformation = () => {
  const navigate = useNavigate();
  const { status, error } = useCompany();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || status === "loading" || status === "noCompany") return;
    done.current = true;
    const newURL = localStorage.getItem("from");
    localStorage.removeItem("from");

    if (status === "error") {
      console.log(error);
      return;
    }

    const isActualPath = routes.some((route) => route.href === newURL);
    if (newURL && newURL !== "/" && isActualPath) {
      navigate(`${newURL}`);
    } else {
      navigate("/dashboard");
    }
  }, [status, error, navigate]);

  return (
    <Box
      h="100vh"
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Spinner />
    </Box>
  );
};

export default CheckInformation;
